module.exports = __webpack_public_path__ + "static/media/gt-logo-white.2bf631b6.jpg";